import SettingsContent from '../Wrapper';
import Index from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/subscription'),
      component: SettingsContent,
      props: {
        headerTitle: 'CHATLYN_SUBSCRIPTION.TITLE',
        icon: 'receipt-money',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'subscription_settings_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
